module.exports = __webpack_public_path__ + "01_long_gold.509d2895.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/01_long_gold.png
// module id = vjul
// module chunks = 0